export function byRanking(a, b) {
	return a.ranking - b.ranking;
}
